var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 760 800",
    style: {
      enableBackground: "new 0 0 760 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h759.8v800H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.8,50c104.9,0,189.9,89.5,189.9,200v300c0,110.5-85,200-189.9,200H189.9C85,750,0,660.5,0,550V250 C0,139.5,85,50,189.9,50H569.8z M210,334.8L47.5,505.9V550c0,81,60.9,146.9,137.1,149.9l5.3,0.1h366.8L210,334.8z M712.3,288.2 L472.6,540.6l143.6,151.2c54.3-19.7,93.8-73,96-136.3l0.1-5.6V288.2z M569.8,100H189.9C113,100,50.3,164.1,47.5,244.4l-0.1,5.6 v185.2l128.9-135.7c17.7-18.6,45.9-19.5,64.6-2.5l2.6,2.5L439,505.3l270.5-284.8c-12.7-66.9-67.7-117.8-134.4-120.4L569.8,100z  M441.6,150c52.5,0,95,44.8,95,100s-42.5,100-95,100s-95-44.8-95-100S389.2,150,441.6,150L441.6,150z M441.6,200 c-26.2,0-47.5,22.4-47.5,50s21.3,50,47.5,50s47.5-22.4,47.5-50S467.8,200,441.6,200z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.1003435eb29497245ef0ad349d4e18d9.svg";
export { ForwardRef as ReactComponent };